<template>
  <div class="WordCloud" ref="chart">
  </div>
</template>

<script>
import * as echarts from 'echarts'
import "echarts-wordcloud"
export default {
  name: "Pie",
  props: [
    'info',
  ],
  components: {

  },
  data() {
    return {
      myChart: null,
    };
  },
  computed: {
  },
  watch: {
    info: {
      handler(val){
        this.myChart && this.myChart.dispose()
        this.$nextTick(() => {
          this.initChart()
        })
      },
      deep: true,
      immediate: true,
    }
  },
  created() {
    /* 
    
      this.info = {
        name: '示例',
        data: [ 
          // 数据配置同官方文档（https://github.com/ecomfe/echarts-wordcloud）
          // color决定对应文字的颜色 
          { name: "普通朋友", value: 132, color: "red"},
          { value: 735, name: '使用官方配置',
            textStyle: {
              color: 'deepskyblue'
            }
          },
        ],
        custom: {}, // 如果有较大的配置改动，可通过该配置（官方文档）进行覆盖
      }
    */
    
  },
  mounted() {
  },
  methods: {
    initChart(){
      let {
        data = [],
        custom = {},
      } = this._.cloneDeep(this.info || {})
      
      data.forEach(x => {
        if(x.color) {
          x.textStyle = {
            color: x.color
          }
        }
      })

      data.sort((a, b) => +b.value - +a.value )
      
      let option = {
        left: 'center',
        top: 'center',
        width: '100%',
        height: '100%',
        right: null,
        bottom: null,
        layoutAnimation: true,
        series: [
          {
            type: "wordCloud",
            shape: 'diamond', //circle`、 cardioid 、 diamond 、 triangle-forward 、 triangle 、 star
            gridSize: 20,
            sizeRange: [14, 60],
            rotationRange: [0, 0],
            drawOutOfBound: false,
            textStyle: {
              fontWeight: "500",
              fontFamily: "OPPOSans",
              color: function(params) {
                // if(params.dataIndex === 0) return "#FF5500"
                let colors = ["#FFA555", "#38A1FF", "#FF5C00", "#FF5500", "#3CD495"]
                // let portion = data.length / colors.length
                // for(let i = 0; i < colors.length; i++) {
                //   if(params.dataIndex <= parseInt((i + 1) * portion) && params.dataIndex > parseInt((i) * portion)) {
                //     return colors[i]
                //   }
                // }

                // 上面那种计算是根据数值大小  但是当数据量巨大且数据量值非常相似的情况下 颜色值展示不友好
                return `${colors[params.dataIndex % 5]}`
              }
            },
            data: data
          }
        ]
      }

      if(data.length){
        option.title = {
          show: false,
          top:0,
          left:0
        }
      }else{
        option.title = {
          show: true,
          text: '暂无数据',
          top: 'middle',
          left: 'center'
        }
      }
      option = this._.merge(option, custom)

      if(!this.$refs.chart){return}
      this.myChart = echarts.init(this.$refs.chart)
      this.myChart.setOption(option)
    },
    
  }

};
</script>

<style scoped lang="less">
.WordCloud{
  width: 100%;
  height: 100%;
}
</style>